import axios from 'axios';
import { BlogPost } from '../types/BlogPost';
import { MenuItem } from '../types/MenuItem';
import { Category } from '../types/Category';
import { SiteSettings } from '../types/SiteSettings';
import { Subscription } from '../types/Subscription';
import { Comment } from '../types/Comment';
import { User } from '../types/User';

// Create an axios instance with default config
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://lummies-femme-circle-88feade09bd7.herokuapp.com/api',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const imageApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://lummies-femme-circle-88feade09bd7.herokuapp.com/api',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

// Add a request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

imageApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Image upload API
export const uploadImage = (file: any) => imageApi.post<any>('/upload/image', file);

// Blog Posts API
export const getPosts = (categoryId?: string, search?: string, page?: number, limit?: number) => {
  const params: Record<string, string | number> = { status: 'published' };

  if (categoryId) {
    params.categoryId = categoryId;
  }

  if (search) {
    params.search = search;
  }

  if (page !== undefined) {
    params.page = page;
  }

  if (limit !== undefined) {
    params.limit = limit;
  }

  return api.get<BlogPost[]>('/posts', { params });
};

export const getPost = (id: string, incrementViews: boolean = true) => {
  const params: Record<string, string | boolean> = {};
  if (!incrementViews) {
    params.incrementViews = false;
  }
  return api.get<BlogPost>(`/posts/${id}`, { params });
};

// Post Likes API
export const toggleLikes = (id: string, userId: string, isLike: boolean) => {
  const params: Record<string, string | boolean> = { 
    userId: userId,
    isLike: isLike
  };

  return api.get<BlogPost>(`/posts/toggle/${id}`, { params });
};

// Categories API
export const getCategories = (page?: number, limit?: number) => {
  const params: Record<string, string | number> = {};
  if (page !== undefined) {
    params.page = page;
  }

  if (limit !== undefined) {
    params.limit = limit;
  }
  return api.get<Category[]>('/categories', { params });
}

// Menu Items API
export const getMenuItems = () => api.get<MenuItem[]>('/menu');

// Site Settings API
export const getSiteSettings = () => api.get<SiteSettings>('/settings');


// Social Menu API
export const getSocialMenu = () => api.get<any>('/menu');

// Site Settings API
export const getRecentPosts = () => api.get<any>('/dashboard/recent-posts?status=published');

// Subscription API
export const createSubscription = (subscribe: Omit<Subscription, 'id'>) => api.post<Subscription>('/subscribe', subscribe);

// Comment API
export const createComment = (comment: Omit<Comment, 'id'>, isReply?: boolean) => {
  if (isReply) {
    return api.post<Comment>('/comments/reply', comment);
  }
  return api.post<Comment>('/comments', comment);
};
export const getComments = (id: string, page?: number, limit?: number) =>
  api.get<Comment>(`/comments?postId=${id}&page=${page}&limit=${limit}&nested=true`);

export const likeComment = (id: string) => api.post<Comment>(`/comments/${id}/like`);
export const dislikeComment = (id: string) => api.post<Comment>(`/comments/${id}/dislike`);
export const deleteComment = (id: string) => api.delete(`/comments/${id}`);

// Auth API
export const login = (email: string, password: string) => 
  api.post<{ token: string; user: Omit<User, 'email'> & { email?: string } }>('/auth/login', { email, password });
export const createUser = (user: Omit<User, 'id'>) => api.post<User>('/auth/register', user);
export const updateUser = (user: Omit<User, 'id'>, id: string) => api.put<User>(`/auth/edit/${id}`, user);
export const forgotPassword = (password: any) => api.post<any>('/auth/forgot-password', password);
export const resetPassword = (password: string, token: string) => api.post<any>(`/auth/reset-password/${token}`, { password });

export default api; 